import axios, { getData } from 'lib/axios'

export const profile = async (data) => {
  return axios.put('/profiles', data).then(getData)
}

export const jobseekerImage = async (data) => {
  return axios.post('/jobseeker_images', data).then(getData)
}
